var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{ref:"editor",attrs:{"id":"editor-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }